<h3>{{ 'notification.filter.title' | translate }}</h3>

<div class="r">
	<mat-button-toggle-group class="first-group">
		<mat-button-toggle
			(click)="
				setFilter('endName', null); setFilter('level', null); setFilter('change', null)
			"
			[class.active]="filtersAreClear"
		>
			{{ 'currency.list.filter.all' | translate }}
		</mat-button-toggle>
		<mat-button-toggle
			value="BTC"
			(click)="setFilter('endName', 'BTC')"
			[class.active]="isInFilterArray('endName', 'BTC')"
		>
			BTC
		</mat-button-toggle>
		<mat-button-toggle
			value="ETH"
			(click)="setFilter('endName', 'ETH')"
			[class.active]="isInFilterArray('endName', 'ETH')"
		>
			ETH
		</mat-button-toggle>
		<mat-button-toggle
			value="BNB"
			(click)="setFilter('endName', 'BNB')"
			[class.active]="isInFilterArray('endName', 'BNB')"
		>
			BNB
		</mat-button-toggle>
		<mat-button-toggle
			value="USDT"
			(click)="setFilter('endName', 'USDT')"
			[class.active]="isInFilterArray('endName', 'USDT')"
		>
			USDT
		</mat-button-toggle>
	</mat-button-toggle-group>

	<mat-button-toggle-group class="second-group">
		<mat-button-toggle
			value="UP"
			(click)="setFilter('level', 'UP')"
			[class.active]="isInFilterArray('level', 'UP')"
		>
			UP
		</mat-button-toggle>
		<mat-button-toggle
			value="DOWN"
			(click)="setFilter('level', 'DOWN')"
			[class.active]="isInFilterArray('level', 'DOWN')"
		>
			DOWN
		</mat-button-toggle>
	</mat-button-toggle-group>
</div>

<div class="r third-group">
	<mat-button-toggle
		[value]="ChangeLevel.Up"
		(click)="setFilter('change', ChangeLevel.Up)"
		[class.active]="filters.change === ChangeLevel.Up"
	>
		{{ 'notification.filter.gains' | translate }}
	</mat-button-toggle>
	<mat-button-toggle
		[value]="ChangeLevel.Down"
		(click)="setFilter('change', ChangeLevel.Down)"
		[class.active]="filters.change === ChangeLevel.Down"
	>
		{{ 'notification.filter.drops' | translate }}
	</mat-button-toggle>
</div>

<div class="r">
	<mat-form-field>
		<mat-label>{{ 'notification.filter.interval' | translate }}</mat-label>
		<mat-select [(ngModel)]="selectedInterval">
			@for (i of intervals; track i) {
			<mat-option [value]="i.value">{{ i.label }}</mat-option>
			}
		</mat-select>
	</mat-form-field>

	<mat-form-field>
		<mat-label>{{ 'notification.filter.currency' | translate }}</mat-label>
		<input matInput type="text" [(ngModel)]="selectedCurrency" autocomplete="off" />
	</mat-form-field>
</div>

<div class="r flex-end">
	<button mat-raised-button color="primary" (click)="onFilterClick()">
		{{ 'notification.filter.apply' | translate }}
	</button>
</div>
